import { Modal } from 'antd'
import axios from 'axios'
import log from 'loglevel'
import React from 'react'
import iPackage from '../../package.json'
import errorImg from '../component/common/img/error_img1.png'
import { axios_ } from './axios_'
import { _HLB_HOST, _LOGIN_URL, _TOKEN, CUSTOMIZED_MERCHANT_LIST } from './constants'
import { customTrack, sensorsAutoTrack, sensorsQuick, sensorsSetProfile, sensorsSinglePage } from './sensors/autoTrack'

/**
 * 工具类
 * @author  吴超
 * @date    2018-05-14
 *
 */
export const Utils = {
  /**
   * 获取商户编码
   * @returns {string} 01：运营平台，02：商户平台
   */
  getSystemNo: () => {
    return "02"
  },
  /** 此插码方式已作废*/
  insertChama: () => { },
  /**
   * 获取名称（商户登录后的名称）
   * @returns {string | null} 如果不存在这返回空串
   */
  getName: () => {
    return sessionStorage.getItem("name")
  },
  /**
   * 加载失败页面（用于懒加载的路由）
   * @param isLoading     加载中
   * @param error         加载失败
   * @returns {*}         dom元素
   */
  loadErrorPage: ({ isLoading, error }) => {
    if (error) {//错误页面
      return (
        <div style={{ display: 'flex', paddingTop: 100, justifyContent: 'center' }}>
          <img src={errorImg} alt="" />
        </div>);
    } else {
      return null;
    }
  },
  /**
   * 将逗号分隔的字符串转换成数组
   * @param str   字符串
   * @return      数组
   */
  getArrayFromStr: (str) => {
    let arrs = [];//空数组
    if (!str) return arrs;//防止空指针
    if (str.indexOf(",") <= 0) {//只有一个数时，没有逗号
      arrs.push(str);
    } else {//多个数时，以逗号分隔
      str.split(",").map((item) => {
        arrs.push(item);
      });
    }
    return arrs;
  },
  /** 引入插码文件*/
  insertKefu: (userId, orgName) => {
    const scripts = [...document.getElementsByTagName('script')]
    const isInserted = scripts.some(item => item.src.indexOf('webchat.7moor.com/javascripts/7moorInit.js') > -1)
    if (isInserted) return;
    if (userId && orgName) {
      window.qimoClientId = { userId: userId, nickName: orgName, customField: {} };
    } else {
      window.qimoClientId = Utils.randUnique(1000, 10000, 1) + '';
    }
    let sevenMmoor = document.createElement("script");
    sevenMmoor.src = "https://webchat.7moor.com/javascripts/7moorInit.js?accessId=31529010-52db-11e8-94ba-1b5a52d1a829&autoShow=false&language=ZHCN";//+new Date().getTime();
    sevenMmoor.setAttribute("async", "async");
    let s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(sevenMmoor, s);
  },
  /**
   * 生成随机数
   * @returns {string | null} 如果不存在这返回空串
   */
  randUnique: (start, end, size) => {
    // 全部随机数值
    let allNums = [];
    // 判断获取随机数个数
    size = size ? (size > end - start ? end - start : size) : 1;
    // 生成随机数值区间数组
    for (let i = start, k = 0; i <= end; i++, k++) {
      allNums[k] = i;
    }
    // 打撒数组排序
    allNums.sort(function () { return 0.5 - Math.random(); });
    // 获取数组从第一个开始到指定个数的下标区间
    return allNums.slice(0, size);
  },

  /**
   * 下载文件（常用于excel下载、导出等功能）
   * @param url           url
   * @param fileName      下载文件名
   */
  downloadFile: async (url, fileName) => {
    // let _url =  url.replace('access-token','Authorization');
    const elink = document.createElement('a');
    elink.download = fileName ? fileName : null;
    elink.style.display = 'none';
    elink.href = url
    document.body.appendChild(elink);
    elink.click();//自己触发点击事件
    document.body.removeChild(elink);//点击后移除<a>标签
    // const data = await doGetRequest({
    //   url
    // })
    // console.log('data', data);
  },
  downloadWithToken: (url, fileName) => {
    if (url.indexOf('access-token') < 0) {
      const token = getToken()
      const param = url.indexOf('?') > -1 ? `&access-token=${token}` : `?access-token=${token}`
      url = url + param
    }
    Utils.downloadFile(url, fileName)
  },
  // 支持过个文件下载
  downloadFileMultiple: (url) => {
    const elink = document.createElement('iframe');
    elink.style.display = 'none';
    elink.src = url;
    document.body.appendChild(elink);
  },
  // 支持非同源图片下载, 使用 canvas 绘制一次
  downloadImg: (src, name) => {
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    img.onload = function () {
      canvas.width = this.width;
      canvas.height = this.height;
      ctx.drawImage(this, 0, 0);
      const elt = document.createElement('a');
      elt.setAttribute('href', canvas.toDataURL('image/jpeg'));
      elt.setAttribute('download', name);
      elt.style.display = 'none';
      document.body.appendChild(elt);
      elt.click();
      document.body.removeChild(elt);
    };
    img.src = src;
  },
  /**
   * 判断是不是一个function
   * @param func          方法名或参数名
   * @returns {boolean}   true：是一个function
   */
  isFunction: (func) => {
    return typeof func === "function";
  },
  /**
   * 判断字符串是否为空
   * @param str           字符串
   * @returns {boolean}   true：空
   */
  isEmptyText: (str) => {
    return str === undefined || str === null || str === "";
  },
  /**
   * 判断该账户是否为多级分利
   * @returns {boolean}   true：是，false：否
   */
  isMoreLevels: () => {
    return sessionStorage.getItem("interestCalcType") === "M";//M:多级分利，T：传统经代
  },
  /**
   * 打印log日志（生产环境不会打印）
   * @param logText
   */
  showLog: (logText) => {
    log.info(logText);
    console.log('REACT_APP_MOCK_REPO_ID:', process.env.REACT_APP_MOCK_REPO_ID)
  },
  /** 对js-cookie的二次封装*/
  cookimanager: {
    set: (str) => {
      Utils.cookimanager.set()
    },
  },
  /**
   * 将DataURL转为Blob对象
   * @param   dataurl     base64编码的图片
   * @return  blob        blob对象，二进制文件
   **/
  dataURLtoBlob: (dataurl) => {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];//去掉url的头部
    let bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  },
  /**
   * 上传图片（注意：参数为JSON对象）
   * @param   url             服务器地址
   * @param   dataUrl         图片base64编码格式的文件
   * @param   imageName       图片名称（一般情况下取file.name属性，如：wuchao.jpg）
   * @param   token           token
   * @return  Promise         异步对象
   **/
  updateImage: ({ url, dataUrl, imageName, token }) => {
    if (!imageName) throw new Error("上传图片失败，imageName不能为空");
    let param = new FormData();  // 创建form对象
    let blobData = Utils.dataURLtoBlob(dataUrl)
    param.append('file', blobData) // 添加form表单中blob
    param.append('fileName', imageName) // 添加form表单中blob
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': token
      }
    };
    return new Promise(resolve => {
      axios.post(url, param, config)
        .then(response => {
          resolve(response.data);
        }).catch(() => {
          Modal.error({
            title: "提示",
            content: "上传失败",
          });
        })
    });

  },
  /**
   * 设置用户信息缓存
   * @param data
   */
  setUserData: (data) => {
    sessionStorage.setItem("userData", typeof data === "object" ? JSON.stringify(data) : "{}");
    sensorsSetProfile(data);
  },
  /**
   * 从缓存中取出用户信息
   */
  getUserData: () => {
    return JSON.parse(sessionStorage.getItem("userData") || '{}');
  },
  /**
   * 是否为工号登录（是否为业务员编码登录方式）
   * @return {boolean}
   */
  isIDLogin: () => {
    return Utils.getUserData().hasOwnProperty("accoutType") && Utils.getUserData().accoutType === "2";
  },
  getOrgId: () => {
    const { orgId = '' } = Utils.getUserData() || {}
    return localStorage.getItem('orgId') || orgId;
  },
  getOrgCname: () => {
    const { orgCname = '' } = Utils.getUserData() || {}
    return orgCname;
  },
  getCompanyId: () => {
    const { companyId = '' } = Utils.getUserData() || {}
    return companyId;
  },
  getCompanyName: () => {
    const { companyName = '' } = Utils.getUserData() || {}
    return companyName;
  },
  getUserId: () => {
    const { userId = '' } = Utils.getUserData() || {}
    return userId;
  },
  getCompanyLevelId: () => {
    const { companyLevelId = '' } = Utils.getUserData() || {}
    return companyLevelId;
  },
  getMobilePhone: () => {
    const { mobilePhone = '' } = Utils.getUserData() || {}
    return mobilePhone;
  },
  // 当前登录管理员是否为商户
  isCommercial: () => {
    const { companyLevelId = '' } = Utils.getUserData() || {}
    return companyLevelId === '10005';
  },
  // 入参机构是否为当前登录机构
  isSelfCompany: (companyId = '') => {
    return Utils.getCompanyId() === companyId
  },
  // 替换百分号为`00REPLACE00`
  // todo: 弃用该函数，所有通过使用 encodeURIComponent API来做 地址栏穿参的地方，都需要将decodeURIComponent换成URLSearchParams来解析参数，如果接着使用decodeURIComponent会报错。
  // 使用方法，参考roleManager/index.js、 roleManager/detail.js
  decodeString: (str = '') => {
    return str ? ('' + str).replace(/RE00PLA00CE/g, '%') : ''
  },
  // 还原百分号
  encodeString: (str = '') => {
    return str ? ('' + str).replace(/%/g, 'RE00PLA00CE') : ''
  },
  // 页面埋点
  sensorsAutoTrack,
  // 单独事件埋点
  sensorsQuick,
  // 单独页面埋点
  sensorsSinglePage,
  // 自定义事件埋点(非全埋点)
  customTrack,
  // 判断是否为海量保域名
  isHLB: () => {
    let isHLB = false;
    _HLB_HOST.forEach(item => {
      if (window.location.hostname.includes(item)) {
        isHLB = true;
        return;
      }
    })
    return isHLB;
    // return window.location.hostname.includes(_HLB_HOST);
  },
  // 海量保，根据环境获取orgId
  getHlbOrgIdByEnv: () => {
    const proOrgId = '1921438678549667840';
    const stagingOrgId = '1923528218173120512';
    const testOrgId = '1921625741513334784';
    if (window.location.hostname === '51chudan.520haibao.com') return proOrgId;
    if (window.location.hostname.includes('uat.51chudan.520haibao.com')) return stagingOrgId;
    if (window.location.hostname.includes('test.51chudan.520haibao.com')) return testOrgId;
  }
};
/**
 * 把普通json转换成antd Form需要的格式，用于this.props.form.setFields(obj) 方法
 * @param json  json对象
 * @returns 返回格式{name:{value:'zhangsan'},age:{value:25}}
 */
export const getFields = (json) => {
  if (!json || typeof json !== 'object' && Object.keys(json).length <= 0) return {};
  let fields = {};
  Object.keys(json).map(key => {
    fields[key] = { value: json[key] }
  });
  return fields;
};
// 获取应用token
export const getToken = () => {
  let tokenInfo = getPlatformTokenInfo();
  return tokenInfo['token_type'] && tokenInfo['access_token'] ? tokenInfo['token_type'] + tokenInfo['access_token'] : '';
}

/**
 * 从localstorage中获取token信息
 * @return {Object | {}} 返回值类型为Object
 */
export const getPlatformTokenInfo = () => {
  return JSON.parse(localStorage.getItem(_TOKEN) || '{}');
};
/** 设置token信息，存到localstorage*/
export const setPlatformTokenInfo = (token) => {
  localStorage.setItem(_TOKEN, token || '{}');
};
/**
 * 判断是否是合法IP
 * @param {string} ip ip字符串
 */
export function checkIp (ip) {
let reg = /^(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])$/;
return reg.test(ip);
}

export function checkDomain () {
let domain = document.domain;
return checkIp(domain)
    ? ''
    : document.domain
    .split('.')
    .slice(-2)
    .join('.');
}
function clearAllLocalStorage() {
    Object.keys(localStorage).forEach(function(key) {
      localStorage.removeItem(key);
    });
}
/** 清除应用中的所有缓存*/
export const clearAllStorage = () => {
  window.localStorage && window.localStorage.removeItem(_TOKEN);
  window.localStorage && window.localStorage.removeItem(_LOGIN_URL);
  window.localStorage && window.localStorage.removeItem('payUrlFlag');
  window.localStorage && window.localStorage.removeItem('orgId');
  window.sessionStorage && window.sessionStorage.clear();
  clearAllLocalStorage();
  let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie =
        keys[i] +
        '=0; expires=' +
        new Date(0).toUTCString() +
        '; path=/;domain=' +
        checkDomain();
      document.cookie =
        keys[i] + '=0; expires=' + new Date(0).toUTCString() + '; path=/';
    }
  }
  // 删除localStroage
  window.localStorage && window.localStorage.clear();
};
/**
 * 判断localstorage中的token是否存在
 * @return Boolean true:存在
 */
export const hasToken = () => {
  return !!(getPlatformTokenInfo().access_token);
};
/** 设置缓存，缓存登陆的url。建议：该方法最好只在登登录口执行成功后调用*/
export const setLoginUrlCache = () => {
  localStorage.setItem(_LOGIN_URL, window.location.hash);
};
/** 从缓存中取出登陆的url*/
export const getLoginUrlCache = () => {
  return localStorage.getItem(_LOGIN_URL);
};
/**
 * 获取session存储对象/值
 * @param sessionObj session key值
 * @param key session Obj key值
 * @returns {*}
 */
export const getSessionObject = (sessionObj, key) => {
  if (sessionStorage.getItem(sessionObj)) {
    return key ? JSON.parse(sessionStorage.getItem(sessionObj))[key]
      : JSON.parse(sessionStorage.getItem(sessionObj))
  } else {
    return null
  }
}
/** 跳转到登陆页*/
export const toLogin = () => {
  // 定制化登录页，根据地址栏url来进行区分
  const search = window.location.search;
  let merchantBelong = new URLSearchParams(search).get('merchantBelong');
  let query = '';
  if (merchantBelong) {
    query = `?merchantBelong=${merchantBelong}`
  } else {
    merchantBelong = localStorage.getItem('merchantBelong');
    const isCustomizedMerchant = CUSTOMIZED_MERCHANT_LIST.some(item => item.merchantBelong === merchantBelong);
    query = isCustomizedMerchant ? `?merchantBelong=${merchantBelong}` : ''
  }
  //从缓存中读取“permission”字段，判断是否是/JingDong路由，如果是则跳转到新登录页；否则跳转到原有的登录页
  let loginPage = sessionStorage.getItem("permission") === "JingDong" ? "/jdLogin" :
    // (getPlatformTokenInfo().loginWay === 'newLogin' ? '/newLogin' : "/login"); // 判断新旧登录入口
    '/login'; // 统一跳转新登录入口
  console.log("hash: " + getLoginUrlCache());
  window.location.hash = (getLoginUrlCache() || `#${loginPage}${query}`);
};
/**
 * 初始化页面的展示字段配置；（合作案）
 * @param routerName // 主页面
 * @param pageName // 子页面
 * @param token
 */
export const initPageNamesConfig = (routerName, pageName, token) => {
  return axios_({
    url: `/api/organization/orgInfo/setting/getDynamicTextInfo`,
    method: 'get',
    headers: { 'Authorization': token },
    params: {
      // orgId: getSessionObject('userData', 'orgId'),
      menuRoute: routerName, // 路由，默认页面
      page: pageName // 子页面
    }
  })
}

//使用refresh_token刷新token的接口
export const getTokens = (params) => {
  return axios_({
    url: 'refreshToken',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json;'
    }
  })
}
/**
 * 校验文件名是否是excell文件，仅认可.xls和.xlsx文件
 * @param fileName    文件名
 * @returns {boolean}
 */
export const isExcel = (fileName) => {
  return /^.*\.(xls(x)?)$/.test(fileName)
}
/**
 * 查询开关状态,
 * @param switchName  开关名称
 * @returns boolean true：开，false：关
 */
export const getSwitchStatus = (switchName = '') => {
  return new Promise((resolve, reject) => {
    axios_({
      url: `/openapi/dic/ref/getDicRef`,
      method: 'get',
      params: {
        dicType: 'orgSetting',
        parentDicKey: switchName,
        thirdPartyId: Utils.getUserData().orgId
      }
    }).then(res => {
      if (res.data.code === 10000) {
        resolve(res.data.data.childDicKey === 'is')
      } else {
        reject(false);
      }
    }).catch(() => {
      reject(false);
    })
  })
};
// 登录管理员是否属于商户（不是机构）
export const isMechant = () => {
  const { companyLevelId } = Utils.getUserData();
  return companyLevelId === '10005';
};
/**
 * 格式化数字：将数值保留2位小数，并且展示千分位。例如，2000.32 => 2,000.32
 * 特殊情况(.00不保留)：例如：2000.00 => 2,000
 * @param num   数字
 * @return {string}
 */
export const numFormat2Thousand = num => {
  if (!num) return '0';
  num *= 1;
  return (parseFloat(num.toFixed(2))).toLocaleString();
};

/**
 * 从字符串中提取数字（包含小数）。例如，输入"张三.100.89,100.00",输出结构为：100.89
 * @param str
 * @return {number}
 */
export const extractNumber = str => {
  if (!str) return 0;
  str += "";
  const matches = str.match(new RegExp("(\\d+(\\.\\d+)?)"));
  return matches && matches.length > 0 ? (matches[0] * 1) : 0;
};
/**
 * 小数位数截断，只舍不入 （2.356=>2.35, ）
 * @param num
 * @param fixed 截取位数
 * @returns {string}
 */
export const toCutNum = (num, fixed) => {
  var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  return num.toString().match(re)[0];
}


/**
 * 校验文件名是否是pdf文件
 * @param fileName    文件名
 * @returns {boolean}
 */
export const isPDF = (fileName) => {
  return /^.*\.(pdf)$/.test(fileName)
}
// 组装埋点信息
export const getAnalysisData = ({
  platform = '商户平台',
  app = '',
  module = '活动',
  source = '商户平台',
}) => {
  return {
    "platform": encodeURIComponent("商户平台"),
    "app": "",
    "module": encodeURIComponent("活动"),
    "source": encodeURIComponent("商户平台"),
    "uid": Utils.getUserData().userId || '',
    "timestamp": new Date().getTime(),
  }
};
// 版本号
export const getAppVersion = () => {
  return {
    "version": iPackage.version,
    "versionCode": iPackage.versionCode
  }
}
// 判断浏览器类型
export const getBrowserType = () => {
  const { userAgent = '' } = window.navigator; //取得浏览器的userAgent字符串
  let isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
  let isIE = userAgent.indexOf("compatible") > -1
    && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
  let isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
  let isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
  let isSafari = userAgent.indexOf("Safari") > -1
    && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
  let isChrome = userAgent.indexOf("Chrome") > -1
    && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

  if (isIE) {
    let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    let fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return "IE7";
    } else if (fIEVersion == 8) {
      return "IE8";
    } else if (fIEVersion == 9) {
      return "IE9";
    } else if (fIEVersion == 10) {
      return "IE10";
    } else if (fIEVersion == 11) {
      return "IE11";
    } else {
      return "0";//IE版本过低
    }
  }
  if (isOpera) {
    return "Opera";
  }
  if (isEdge) {
    return "Edge";
  }
  if (isFF) {
    return "FF";
  }
  if (isSafari) {
    return "Safari";
  }
  if (isChrome) {
    return "Chrome";
  }
}
// 当前浏览器是否为推荐浏览器
export const recommendBrowser = () => {
  const type = getBrowserType();
  return type === 'Chrome' || type === 'FF'
}
// 防抖
export const debounce = (callback, waitTime) => {
  let timeout = null;
  return () => {
    if (timeout !== null) clearTimeout(timeout);
    timeout = setTimeout(callback, waitTime);
  }
}
// json转换成url的参数,'&'开头
export const json2UrlParams = (data = {}) => {
  const keys = Object.keys(data);
  if (keys.length <= 0) return '';
  return keys.reduce((init, item, index) => {
    const key = keys[index];
    const value = data[key] || '';
    if (index === 0) {
      return `${init}${key}=${value}`
    } else {
      return `${init}&${key}=${value}`
    }
  }, "");
}

export const copyStr = (str, cb) => {
  let e = document.createElement('textarea')
  e.value = str;
  document.body.appendChild(e)
  e.select()
  document.execCommand('Copy')
  document.body.removeChild(e)
  if (cb) {
    cb();
  }
}
// mock api前缀
export const getMockAPI = () => {
  return iPackage.mockAPI || '';
}
// mock 代理地址
export const getMockProxy = () => {
  return iPackage.mockProxy || '';
}

// 从props中取路由参数
export const getParamFromProps = (props = {}, key = '') => {
  const {
    match: {
      params = {}
    } = {} } = props;
  return params[key] || '';
}
export const getValueFromJsonStr = (jsonStr = '', key = '') => {
  let value = '';
  try {
    let json = JSON.parse(jsonStr);
    value = json[key] || ''
  } catch (e) { }
  return value;
}

// 格式化为千分位
export const toFix0 = num => {
  if (!num) return 0;
  return (num *= 1).toLocaleString()
};
// 转换成<br />形式的换行
export const getDescToBR = (desc = '') => {
  if (!desc) return '';
  return desc.replace(/\r{0,}\n/g, "<br/>")
};

export const sleep = (duration) => {
  return new Promise(function (resolve) {
    setTimeout(resolve, duration);
  })
}

export const matchAdditionType = type => {
  switch (type) {
    case '10':
      return '加保';
    case '11':
      return '减保';
    case '12':
      return '已撤单';
    case '13':
      return '犹豫期退保';
    case '14':
      return '部分退保';
    case '15':
      return '已退保';
    case '16':
      return '协议退保';
    default:
      return '-';
  }
};

// 检验商户是否开通APP
export const checkOrgOpenPresent = () => {
  return axios_({
    url: `/api/organization/app/present2/${Utils.getOrgId()}`,
    method: 'get',
    headers: { 'Authorization': getToken() }
  })
};

// 手机号脱敏
export const phoneDesensitize = (phone) => {
    const reg = /(\d{3})\d*(\d{4})/;
    return phone ? phone.toString().replace(reg, '$1****$2') : '';
};

// 身份证号脱敏
export const idNumberDesensitize = (idNum) => {
    const reg = /(\d{3})\d*(\d{4})/;
    return idNum ? idNum.toString().replace(reg, '$1**********$2') : '';
};

// 公司名称脱敏
export const personOrCompanyDesensitize = (name) => {
    if(name.length <= 3) {
        return nameDesensitize(name);
    }
    const reg = /([\u4e00-\u9fa5]{3})[\u4e00-\u9fa5]*([\u4e00-\u9fa5]{4})/;
    return name ? name.toString().replace(reg, '$1**********$2') : '';
};

// 地址脱敏
export const addressDesensitize = (name) => {
    if(!name) {
        return ''
    }
    if(name.length <= 3) {
        return nameDesensitize(name);
    }
    const reg = /([\u4e00-\u9fa5]{2})[\u4e00-\u9fa5]*([\u4e00-\u9fa5])/;
    return name ? name.toString().replace(reg, '$1**********') : '';
};

// 邮箱脱敏
export const emailDesensitize = (name) => {
    const reg = /(\w{1}).*(\w{1})@(.*)/;
    return name ? name.toString().replace(reg, '**********@$3') : '';
};

// 带名字的手机号脱敏
export const phoneWithNameDesensitize = (str) => {
    str.match(/[+]?\d{11}|\(\d{3}\)\s?-\d{6}/);
    return str ? phoneDesensitize(str) : '';
};

// 人名脱敏
export const nameDesensitize = (name) => {
    const nameList = name.split('');
    nameList.splice(1, 1, '*');
    return nameList.join('');
};

//泰康保单号修改展示样式
export const taiKangInsurancePolicyShow = (str) => {
  if(str && str.indexOf('_lima_') > -1){
    return str.split('_lima_')[0];
  }
  return str;
};

//获取这个链接"https://consultant-v12-shop.test.zhongbaounion.com/activities/adviser?appointmentConsultantConfigId=1731852152469700608&orgId=2013499439135989760&adviserSource=%E7%83%AD%E7%83%AD%E7%83%AD23&style=1"中的style值
export const getStyleFromUrl = (url) => {
  if(!url) {
    return '';
  }
  const reg = /style=(\d+)/;
  const match = url.match(reg);
  return match? match[1] : '';
};


/**
 * 姓名脱敏处理
 * @param name 原始姓名
 * @returns 脱敏后的姓名
 */
export const desensitizeName = (name)=> {
    const length = name.length;

  if (length < 2) {
    // 两个字以内，直接把中间字替换为 *
    return name[0] + '*';
  }
  if (length == 2) {
    // 两个字以内，直接把中间字替换为 *
    return name[0] + '*'+ name[1];
  }

  const first = name[0];
  const last = name[length - 1];
  const masked = '*'.repeat(length - 2);

  return first + masked + last;
  }
